import { Link } from "react-router-dom";
import { SEO } from "@/components/SEO";

const SECTIONS = [
  {
    title: "Cancelling a session",
    body: "Only confirmed, upcoming sessions can be cancelled — from your My Bookings page, in one click.\n\n• Cancel 24 hours or more before the session: you receive a full, automatic refund to your original payment card.\n• Cancel less than 24 hours before the session: no automatic refund, out of respect for the practitioner's reserved time.\n\nRefunds are returned to your card and typically appear within 5–10 business days, depending on your bank.",
  },
  {
    title: "If a practitioner can't make it",
    body: "If your practitioner needs to cancel or doesn't show, contact us right away at ourrippleeffectcommunity@gmail.com or through the contact page — you'll receive a full refund, no questions asked. Practitioners who repeatedly cancel are reviewed by O.R.E.C.",
  },
  {
    title: "Reviews and the 1-star promise",
    body: "Reviews can be left after a completed session, and honesty is welcome. To keep things fair for everyone: a 1-star review is first held privately, so the seeker and practitioner have a chance to resolve the issue together before anything goes public. If it isn't resolved in time, O.R.E.C steps in.",
  },
  {
    title: "Leader listings & featured months",
    body: "Leader listings are free for a practitioner's first year. After that, Leader listings ($15 per 30 days) and Featured placements ($25 per 30 days) begin immediately upon purchase and run their full term. They are not refundable once active — Leaders control month to month whether to renew.",
  },
  {
    title: "Tips",
    body: "Tips sent through Support Bridgett are gifts of appreciation and are not refundable.",
  },
  {
    title: "Questions?",
    body: "Anything unclear or a situation not covered here — reach out through the contact page or email ourrippleeffectcommunity@gmail.com. A real person on The Team reads every message.",
  },
];

export default function Policies() {
  return (
    <div className="silk-hero min-h-[70vh] px-5 sm:px-8 py-16">
      <SEO title="Cancellations & Refunds — O.R.E.C" description="O.R.E.C's simple, fair cancellation and refund policies for seekers and practitioners." />
      <div className="max-w-2xl mx-auto" data-testid="policies-page">
        <p className="text-xs uppercase tracking-[0.25em] text-muted-foreground mb-3">Policies</p>
        <h1 className="font-display text-4xl sm:text-5xl text-foreground mb-3">Cancellations & refunds</h1>
        <p className="text-sm text-muted-foreground mb-12 leading-relaxed">
          Simple and fair, for both sides of every session. New to booking? Start with{" "}
          <Link to="/how-booking-works" className="text-primary hover:underline">How booking works</Link>.
        </p>
        <div className="space-y-10">
          {SECTIONS.map((s) => (
            <section key={s.title} data-testid={`policy-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <h2 className="font-display text-base md:text-lg text-foreground mb-3">{s.title}</h2>
              <p className="text-sm text-muted-foreground leading-relaxed whitespace-pre-line">{s.body}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
